import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import HeroSection from "./HeroSection";
import Benefit from "./Benefit";
import Navigation from "../../Navbar";
import Desc from "./Desc";
import Definition from "./Definition";
import StatutoryLaws from "./StatutoryLaws";
import ContentAssessment from "./ContentAssessment";
import Provision from "./Provision";
import LCAProcess from "./LCAProcess";
import FAQ from "./FAQ";
import Impartiality from "./Impartiality";
import HandlingProcess from "./HandlingProcess";
import ComplainForm from "./ComplainForm";
import ContactUs from "./ContactUs";
import Commitment from "./Commitment";

function Tkdn() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const contactUs = [
    {
      name: "Marketing TKDN",
      email: "marketing_tkdn@anindya.biz",
      phone: "",
    },
    {
      name: "Gressella",
      email: "gressella@anindya.biz",
      phone: "+62 857-1898-5849",
    },
    {
      name: "Ahmad Syoufi",
      email: "ahmad.syoufi@anindya.biz",
      phone: "+62 812-1111-4619",
    },
    {
      name: "Gilang Aditia Perdana",
      email: "gilang.aditia@anindya.biz",
      phone: "+62 813-9824-9449",
    },
  ];

  return (
    <>
      <Navigation />
      <HeroSection />
      <div style={{ backgroundColor: "#F2F2F2" }}>
        <Desc />
      </div>
      <Definition />
      <div style={{ backgroundColor: "#F2F2F2" }}>
        <Benefit />
      </div>
      <StatutoryLaws />
      <div style={{ backgroundColor: "#F2F2F2" }}>
        <ContentAssessment />
      </div>
      <Provision />
      <div style={{ backgroundColor: "#F2F2F2" }}>
        <LCAProcess />
      </div>
      <FAQ />
      <div style={{ backgroundColor: "#F2F2F2" }}>
        <Impartiality />
      </div>
      <Commitment />
      <div style={{ backgroundColor: "#F2F2F2" }}>
        <HandlingProcess />
      </div>
      <ComplainForm />
      <div style={{ backgroundColor: "#F2F2F2" }}>
        <ContactUs data={contactUs} sectionTitle={"contact_title"} />
      </div>
    </>
  );
}

export default Tkdn;
